import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import searchIcon from '../../../../../images/icons/search.svg';
import styles from './Icon.module.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';

function Icon(props) {
  const { onClick, className } = props;
  return (
    <ClickableDiv
      className={cx(styles.icon, className)}
      onClick={onClick}
    >
      <img src={searchIcon} alt="search" />
    </ClickableDiv>
  );
}

Icon.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default Icon;
